import { render, staticRenderFns } from "./locate-playback-BD.vue?vue&type=template&id=6735c3c8&scoped=true"
import script from "./locate-playback-BD.vue?vue&type=script&lang=js"
export * from "./locate-playback-BD.vue?vue&type=script&lang=js"
import style0 from "./locate-playback-BD.vue?vue&type=style&index=0&id=6735c3c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6735c3c8",
  null
  
)

export default component.exports